module.exports = __webpack_public_path__ + "static/media/16UNODC35.12409894.jpg";